import type { FallbackProps } from 'react-error-boundary';
import { Box, Button, Typography, Paper } from '@mui/material';

export function ErrorFallback({ error, resetErrorBoundary }: FallbackProps) {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        p: 3,
      }}
    >
      <Paper sx={{ p: 4, maxWidth: 600, textAlign: 'center' }}>
        <Typography variant="h4" gutterBottom color="error">
          Something went wrong
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
          {error.message || 'An unexpected error occurred'}
        </Typography>
        <Button variant="contained" onClick={resetErrorBoundary}>
          Try again
        </Button>
      </Paper>
    </Box>
  );
}
